<script>
  import { onMount } from "svelte";
  import backend from "../server.js";
  import PaginationV2 from "../lib/components/PaginationV2.svelte";
  import ModalListBanners from "../lib/components/modals/clients/banners/ModalListBanners.svelte";
  import { getClientFilterCodes } from "../js/credentialsApi.js";

  let selectedClient = null;
  let showModalEditCarrusel = false;
  let clients = [];
  let loading = false;
  let error = "";
  let page = 1;
  let total = 0;
  let xpage = 10;
  let search = "";

  onMount(() => fetchClients());

  async function fetchClients() {
    loading = true;
    error = "";
    try {
      const params = { page, xpage, platform: 1 };
      if (search.trim()) params.search = search.trim();

      const allowedCodes = await getClientFilterCodes();
      if (allowedCodes === null) {
        // superadmin: all clients, no filter
      } else if (allowedCodes.length) {
        params.codes = allowedCodes.join(",");
      } else {
        clients = [];
        total = 0;
        return;
      }

      const response = await backend.client.lists(params);
      const dataList = Array.isArray(response?.data?.list) ? response.data.list : [];
      clients = dataList;
      total = Number(response?.data?.total) || 0;
    } catch (err) {
      error = "Error al cargar clientes";
      console.error(err);
    } finally {
      loading = false;
    }
  }

  function handleSearchEnter(e) {
    if (e.charCode === 13) {
      page = 1;
      fetchClients();
    }
  }

  function handleSearch() {
    page = 1;
    fetchClients();
  }

  function handlePageClick(nextPage) {
    page = nextPage;
    fetchClients();
  }

  function handleReload() {
    page = 1;
    search = "";
    fetchClients();
  }

  function editCarrusel(item) {
    selectedClient = item;
    showModalEditCarrusel = true;
  }
</script>

<div class="clients-page">
  <header class="d-flex justify-content-between align-items-center mb-4">
    <h4 class="fw-bold mb-0">Lista de clientes</h4>
    <div class="d-flex align-items-center gap-2">
      <input
        bind:value={search}
        on:keypress={handleSearchEnter}
        class="form-control form-control-sm"
        placeholder="Buscar"
        style="width: 180px"
      />
      <button class="btn btn-primary btn-sm" title="Buscar" on:click={handleSearch}>
        <i class="fa-solid fa-magnifying-glass"></i>
      </button>
      <button
        class="btn btn-outline-secondary btn-sm"
        on:click={handleReload}
        disabled={loading}
      >
        <i class="fa-solid fa-rotate-right"></i>
      </button>
    </div>
  </header>

  {#if loading}
    <div class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Cargando…</span>
      </div>
      <p class="mt-2 text-muted small">Cargando clientes…</p>
    </div>
  {:else if error}
    <div class="alert alert-danger d-flex align-items-center gap-2">
      <i class="fa-solid fa-circle-exclamation"></i>
      <span>{error}</span>
    </div>
  {:else if clients.length === 0}
    <div class="alert alert-info">No hay clientes registrados.</div>
  {:else}
    <div class="table-responsive">
      <table class="table table-hover align-middle mb-0">
        <thead class="table-light">
          <tr>
            <th>Código</th>
            <th>Nombre del sitio</th>
            <th class="text-center" style="width: 8rem">Opciones</th>
          </tr>
        </thead>
        <tbody>
          {#each clients as client (client.id)}
            <tr>
              <td><code>{client.code}</code></td>
              <td>{client.namesite}</td>
              <td class="text-center">
                <button
                  class="btn btn-sm btn-outline-primary"
                  title="Editar banner"
                  on:click={() => editCarrusel(client)}
                >
                  <i class="fa-solid fa-image"></i>
                </button>
              </td>
            </tr>
          {/each}
        </tbody>
      </table>
    </div>

    <PaginationV2 {total} {xpage} current={page} onPageClick={handlePageClick} />
  {/if}
</div>

{#if showModalEditCarrusel && selectedClient}
  <ModalListBanners bind:showModalEditCarrusel client={selectedClient} />
{/if}

<style>
  .clients-page :global(.table) {
    font-size: 0.9rem;
  }
  .clients-page code {
    font-size: 0.85rem;
  }
</style>
